import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { HeadersState, HeaderState, HeadersApiResponse } from '../types';

const initialState: HeadersState = {
  headers: [],
};

const headersSlice = createSlice({
  name: 'headers',
  initialState,
  reducers: {
    setHeadersAction(state, action: PayloadAction<HeadersApiResponse>) {
      state.headers = action.payload.headers;
    },

    clearHeadersAction(state) {
      state.headers = initialState.headers;
    },
  },
});

export const { setHeadersAction, clearHeadersAction } = headersSlice.actions;

export const getHeaders = (state: RootState): HeaderState[] => state.headers.headers;

export default headersSlice.reducer;
